// @ts-ignore
import core from '@gvdasa/gv-core';
import {Environment} from '../../../environment';
import { useContext, ReactNode } from 'react';
import { ComponentsContext } from '../../../contexts/ComponentsContext';
import { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { ORIGIN_HEADER, originToHeaderValue } from '../../../utils/urlHelper';

export const Api = core.GVHttpClient(Environment);

interface AxiosConfigProps {
	children: ReactNode;
}

interface HeadersConfig {
	[key: string]: string;
}

export interface ErrorResponse {
	response?: {
		data?: {
			mensagem?: string;
		};
	};
	message?: string;
}

export const AxiosConfig = ({ children }: AxiosConfigProps): ReactNode => {
	const { tenant, environment, origin, handleGetToken, withCredentials } = useContext(ComponentsContext);
	const token = handleGetToken ? handleGetToken() : null;

	if(!!tenant && !!environment && !!token) {
		Api.interceptors.request.use(async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
			config.headers = {
				...config.headers,
				Idtenant: tenant,
				baseURLRefer: window.location.origin,
				[ORIGIN_HEADER]: originToHeaderValue(origin),
				...(withCredentials ? {} : { Authorization: `Bearer ${await handleGetToken()}` }),
			} as HeadersConfig;

			return config;
		});
	}

	return children;
};